















// @ts-nocheck
// tslint:disable no @ts-nocheck
import StandardNavigation from "@/components/Customizer/StandardNavigation";
import StandardArrowNavigation from '../StandardArrowNavigation/StandardArrowNavigation.vue';
import { IComponentsPdm, IConfiguration } from "@/store/modules/utils/util.t";
import {
  IDefaultRecipe,
  IComponentRecipe,
  IComponentTemplate,
} from "@/store/modules/recipe/recipe.t";
import { IPDM } from "@/store/modules/utils/util.t";
import { ISwatch } from "@/store/modules/swatches/swatches.t";
import { TreeNode } from "@/components/Customizer/StandardNavigation/StandardNavigation.t";
import Vue, { VueConstructor } from "vue";

export default (Vue as VueConstructor<Vue>).extend({
  components: {
    StandardNavigation,
    StandardArrowNavigation,
  },
  data() {
    return {
      showFlyout: false as boolean
    };
  },
  computed: {
    activeComponent(): string {
      const isApparel = this.$store.getters['utils/isApparelEnabled'];
      if (isApparel){
        return this.$store.state.standardNavigation.activeSubComponent !== '' ?
        `${this.$store.state.standardNavigation.activeComponent}/${this.$store.state.standardNavigation.activeSubComponent}`:
          this.$store.state.standardNavigation.activeComponent;
      }
      else {
        return this.$store.state.legacyNavigation.activeComponent;
      }
    },
    configuration(): IConfiguration {
      return this.$store.state.utils.configuration;
    },
    defaultRecipe(): IDefaultRecipe {
      return this.$store.state.recipe.defaultRecipe;
    },
    pdm(): IPDM {
      return this.$store.state.utils.pdm;
    },
    rayTracerDisabled(): boolean {
      return (
        this.$store.state.utils.trayDisabled.swatches ||
        this.$store.state.utils.trayDisabled.geostates
      );
    },
    zoomLevelHigh() {
      return this.$store.state.utils.zoomLevel >= 200;
    },
  },
  methods: {
    onTreeItemActivated(item: TreeNode): void {
      const activeComponentTemplate: string | number = item.path[1]
        ? `${item.path[0]}/${item.path[1]}`
        : item.path[0];
      const temp = {
        activeComponent: item.path[0] ? item.path[0] : "",
        activeSubComponent: item.path[1] ? item.path[1] : ""
      };
      let storeComponent: IComponentRecipe;
      if (String(activeComponentTemplate).search('/') === -1){
        storeComponent = this.$store.state.recipe.recipe_v2.components[temp.activeComponent];
      } else {
        const component = this.$store.state.recipe.recipe_v2.components[temp.activeComponent];

        storeComponent = component.sub_components && Object.keys(component.sub_components)
        .filter((key: string) => key === temp.activeSubComponent)
        .reduce((cur, key) => { return Object.assign(cur, { [key]: component.sub_components[key] })}, {});
      }

      let storeComponentItem: IComponentTemplate | undefined;
      if (temp.activeSubComponent === '') {
        storeComponentItem = storeComponent;
      } else {
        storeComponentItem = storeComponent && storeComponent[temp.activeSubComponent];
      }
      if (storeComponentItem) {
        if (this.activeComponent !== activeComponentTemplate) {
          this.setPreviousComponent();
        }

        this.$store.dispatch("standardNavigation/UPDATE_STANDARD_NAVIGATION", temp);

        const componentName = String(item.id);
        this.selectComponent(
          componentName as keyof IComponentsPdm,
          this.$customizerDataLayer.types.selectFlyouttMenu,
          true,
          componentName,
          true,
          false,
          false
        );
      } else {
        this.$eventBus.$emit("changeTab", { name: item.id })
      }
    },
    selectComponent(
      componentName: keyof IComponentsPdm,
      dataLayerType:  string | null = null,
      setRotate = true,
      componentDisplayName: string = "",
      componentHighlighting: boolean = true,
      showGraphicEditor: boolean = false,
      updateStandardNavigation: boolean = true,
    ): void {
      const components = componentName.split("/");
      let component = components[0];
      let subcomponent = components.length > 1 ? components[1] : "";
      if (this.rayTracerDisabled && !this.$store.state.utils.isRandomizeApplied) return;
      // checks if the component is the left sleeve and replaces it with the left sleeve
      if (component === "graphic_sleeve_left") component = "graphic_sleeve_right";

      if (updateStandardNavigation && this.activeComponent !== componentName) {
        // tslint:disable
        this.setPreviousComponent();
      }

      if (
        setRotate &&
        this.configuration.enableAutoRotate &&
        this.pdm.components[component] &&
        this.pdm.components[component].position_component
      ) {
        componentHighlighting &&
          this.$eventBus.$emit(
            "rotate-component",
            this.pdm.components[component].position_component,
            component
          );
      } else {
        this.$eventBus.$emit("component-selected", component);
      }
      if (this.$store.getters["utils/returnScreenSize"].includes("mobile")) {
        this.closeFlyout();
      }
      this.$store.commit("legacyNavigation/SET_ACTIVE_COMPONENT", component);
      if (updateStandardNavigation) {
        // for the `shirt_body` component the tab name is `tee-color`
        // all other component and tab names should match when is on the navigation the shoes not need to change the tab
        if(this.$store.getters['utils/isApparelEnabled']) {
          const tabName = component === "shirt_body" ? "tee-color" : component;
          // the setRotate parameter is false to avoid rotating when clicking on the component
          // the trackChangeTabEvent parameter is false to avoid tracking a click event in a tab
          this.$eventBus.$emit("changeTab", { name: tabName }, false, false);
        }
        this.$store.dispatch("standardNavigation/UPDATE_STANDARD_NAVIGATION", {
          activeComponent: component,
          activeSubComponent: subcomponent ?? "",
        });
      }
      // this is commented out until we figure out a way to avoid firing the click event when dragging the 3D model
      // if (showGraphicEditor && this.$store.state.recipe.recipe_v2.components[component].subgroup === "graphics") {
      //   this.$store.commit("graphicsController/SET_EDITOR_VISIBLE", true);
      // }
      const componentsWithUGC =
        this.$store.getters["ugc/getUGCEnabledComponents"];
      if (componentsWithUGC.includes(component)) {
        this.$store.commit(
          "ugc/tempData/SET_ACTIVE_UGC_COMPONENT",
          component
        );
      }
      if (dataLayerType) {
        const componentDisplayName = this.getComponentDisplayName();
        this.setDataLayer(componentDisplayName, dataLayerType);
      }
    },
    setPreviousComponent() {
      this.$store.commit('standardNavigation/SET_PREVIOUS_COMPONENT', this.activeComponent);

      const swatchObj = this.$store.state.swatches.selectedSwatches[this.activeComponent];
      if (swatchObj && !swatchObj.default) {
        this.$store.commit(
          'standardNavigation/SET_LAST_COMPONENT_SWATCH_APPLIED',
          this.activeComponent,
        );
      }
    },
    closeFlyout(): void {
      this.showFlyout = false;
    },
    getComponentDisplayName(): string {
      const componentName = this.$store.state.standardNavigation.activeComponent;
      const subComponentName = this.$store.state.standardNavigation.activeSubComponent;
      const componentNameIdx = this.$store.state.standardNavigation.menu.findIndex((item:any) => item.id === componentName);
      let componentDisplayName = this.$store.state.standardNavigation.menu[componentNameIdx].name;
      if (subComponentName) {
        const subComponentNameIdx =  this.$store.state.standardNavigation.menu[componentNameIdx].children.findIndex((item:any) => item.id === subComponentName);
        const subComponentDisplayName = this.$store.state.standardNavigation.menu[componentNameIdx].children[subComponentNameIdx].name;
        componentDisplayName = componentDisplayName + ": " + subComponentDisplayName;
      }
      return componentDisplayName;
    },
    setDataLayer(componentName: string, type: string): void {
      this.$customizerDataLayer.logAnalyticsEvent({
        model: this.pdm.sku,
        componentName,
        type,
      });
    },
  },
  created(): void {
    this.$eventBus.$on("select-component", this.selectComponent);
  },
  beforeDestroy() {
    this.$eventBus.$off("select-component", this.selectComponent);
  },
});
